
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { LicenseKey } from '@/types/licenseKey';

interface SuperAdminsTabContentProps {
  superAdminLicenses: any[];
  licenseKeys: LicenseKey[];
}

const SuperAdminsTabContent: React.FC<SuperAdminsTabContentProps> = ({ superAdminLicenses, licenseKeys }) => {
  const navigate = useNavigate();
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Super Admin Licenses</CardTitle>
        <CardDescription>Super Admins with active licenses</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-3 px-4 text-sm font-medium">Super Admin</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Domain</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Activated</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {superAdminLicenses.slice(0, 5).map((license) => {
                const key = licenseKeys.find(k => k.id === license.licenseKeyId);
                return (
                  <tr key={license.id} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-4">{key?.superAdminName || license.superAdminId}</td>
                    <td className="py-3 px-4">{license.domain}</td>
                    <td className="py-3 px-4">
                      {new Date(license.activatedAt).toLocaleDateString()}
                    </td>
                    <td className="py-3 px-4">
                      <Badge variant={license.isValid ? 'success' : 'destructive'}>
                        {license.isValid ? 'Valid' : 'Invalid'}
                      </Badge>
                    </td>
                  </tr>
                );
              })}
              {superAdminLicenses.length === 0 && (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-500">
                    No Super Admin licenses found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
      <CardFooter className="flex justify-center border-t pt-4">
        <Button variant="outline" onClick={() => navigate('/master-license/super-admins')}>
          Manage Super Admins
        </Button>
      </CardFooter>
    </Card>
  );
};

export default SuperAdminsTabContent;
